import React, { useState, useEffect } from 'react';
import { useNavigate, BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faUser, faGamepad, faCalendarPlus, faPlusSquare, faTrophy, faMedal, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useTournament } from '../TournamentContext';
import axios from 'axios';
import config from "../../config/default.json";
import { useUtil } from '../Util';


const base_url = config.base_url;

const UpdateTournament = () => {
const [tournament, setTournament] = useState(null);
const [teams, setTeams] = useState([]);

const [name, setUpdatedNames] = useState({});
const [acronym, setacronymNames] = useState({});
const [location, setLocation] = useState({});
const [startdate, setStartdate] = useState({});
const [enddate, setEnddate] = useState({});
const [organization, setOrganization] = useState({});
const [winner, setWinner] = useState({});
const { tournamentID } = useTournament();
const [isPublished, setIsPublished] = useState(false);
const [isCustomStanding, setIsCustomStanding] = useState(true);
const [hasIsPublishedChanged, sethasIsPublishedChanged] = useState(false);
const [hasIsCustomStandingChanged, sethasIsCustomStandingChanged] = useState(false);
const token = localStorage.getItem('token');
const navigate = useNavigate();
const { formatDateWithDashNoTimezone } = useUtil();




 useEffect(() => {
  if (tournamentID) {
    fetchTournament();
    fetchTeams();
  }
}, [tournamentID]);



const fetchTournament = async () => {
  try {
    const response = await axios.get(`${base_url}/api/tournament/id/${tournamentID}`);
     const data = response.data;
    setTournament(data);

    const id = data._id;
    setUpdatedNames({ [id]: data.name });
    setacronymNames({ [id]: data.acronym });
    setLocation({ [id]: data.location });
    setStartdate({ [id]: formatDateWithDashNoTimezone(data.startdate) });
    setOrganization({ [id]: data.organization });
    setWinner({ [id]: data.winner });

    // ✅ Set checkboxes
    setIsPublished({ [id]: data.isPublished });
    setIsCustomStanding({ [id]: data.isCustomStanding });
  } catch (error) {
    console.error('Failed to fetch tournament', error);
  }
};


  const fetchTeams = async () => {
    try {
      const response = await axios.get(base_url + `/api/teams/${tournamentID}`);
      setTeams(response.data);
    } catch (error) {
      console.error('Failed to fetch teams', error);
    }
  };

  const handleTournamentNameChange = (e, tournamentId) => {
    setUpdatedNames((prevNames) => ({
      ...prevNames,
      [tournamentId]: e.target.value,
    }));
  };

  const handleAcronymNameChange = (e, tournamentId) => {
    setacronymNames((prevNames) => ({
      ...prevNames,
      [tournamentId]: e.target.value,
    }));
  };

  const handleLocationChange = (e, tournamentId) => {
    setLocation((prevNames) => ({
      ...prevNames,
      [tournamentId]: e.target.value,
    }));
  };
  
  
  const handleStartdateChange = (e, tournamentId) => {
    setStartdate((prevNames) => ({
      ...prevNames,
      [tournamentId]: e.target.value,
    }));
  };

    const handleEnddateChange = (e, tournamentId) => {
    setEnddate((prevNames) => ({
      ...prevNames,
      [tournamentId]: e.target.value,
    }));
  };

  const handleOrganizationChange = (e, tournamentId) => {
    setOrganization((prevNames) => ({
      ...prevNames,
      [tournamentId]: e.target.value,
    }));
  };

  
  const handleWinnerChange = (e, tournamentId) => {
    setWinner((prevNames) => ({
      ...prevNames,
      [tournamentId]: e.target.value,
    }));
  };
  
  const handleIsPublishedChange = (e, tournamentId) => {
    const isChecked = e.target.checked;
    if(isChecked !== isPublished[tournamentId]) {
      sethasIsPublishedChanged(true)
    };
   // sethasIsPublishedChanged(true);
    setIsPublished((prevIsPublished) => ({
      ...prevIsPublished,
      [tournamentId]: isChecked,
    }));
  };

  const handleIsCustomStandingChange = (e, tournamentId) => {
    const isChecked = e.target.checked;
    if(isChecked !== isCustomStanding[tournamentId]) {
      sethasIsCustomStandingChanged(true)
    };
   // sethasIsPublishedChanged(true);
    setIsCustomStanding((prevIsCustomStanding) => ({
      ...prevIsCustomStanding,
      [tournamentId]: isChecked,
    }));
  };
    

const handleUpdateTournament = async () => {
  try {
    const updatedName = name[tournament._id];
    const updatedAcronym = acronym[tournament._id];
    const updatedLocation = location[tournament._id];
    const updatedStartdate = startdate[tournament._id];
    const updatedEnddate = enddate[tournament._id];
    const updatedOrganization = organization[tournament._id];
    const updatedWinner = winner[tournament._id];
    const updateIsPublished = isPublished[tournament._id];
    const updateIsCustomStanding = isCustomStanding[tournament._id];

    await axios.put(`${base_url}/api/tournaments/${tournament._id}`, {
      name: updatedName || tournament.name,
      acronym: updatedAcronym || tournament.acronym,
      location: updatedLocation || tournament.location,
      startdate: updatedStartdate || tournament.startdate,
      enddate: updatedEnddate || tournament.enddate,
      organization: updatedOrganization || tournament.organization,
      winner: updatedWinner || tournament.winner,
      isPublished: updateIsPublished,
      isCustomStanding: updateIsCustomStanding,
    }, {headers: {
            Authorization: `Bearer ${token}`,
          }},);

    alert('Tournament updated successfully!');
      navigate(`/admin/${tournament.linkindex}/admin`);

  } catch (error) {
    alert('Error: Tournament not updated.');
    console.error('Failed to update tournament', error);
  }
};

  
if (!tournament) {
  return <div>Loading tournament...</div>;
}

  return (
    <div>
        
              <h1>
              <FontAwesomeIcon icon={faPenToSquare} size="1x"/> &nbsp;
            Update Tournament</h1>
     <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '500px' }}>
      <br />
  <div>
    Tournament Linkindex:  &nbsp; <strong>{tournament?.linkindex}</strong>
  </div>
      <br />

  <div>
    <label>Name:</label>
      <br />
    <input
      type="text"
      value={name[tournament._id] || tournament.name}
      onChange={(e) => handleTournamentNameChange(e, tournament._id)}
    />
  </div>

  <div>
    <label>Acronym:</label>
      <br />
    <input
      type="text"
      value={acronym[tournament._id] || tournament.acronym}
      onChange={(e) => handleAcronymNameChange(e, tournament._id)}
    />
  </div>

  <div>
    <label>Start Date:</label> 
      <br />
    <input
  type="date"
  value={startdate[tournament._id] || ''}
  onChange={(e) => handleStartdateChange(e, tournament._id)}
/>

  </div>

   <div>
    <label>End Date:</label> 
      <br />
    <input
      type="date"
      value={enddate[tournament._id] || ''}
      onChange={(e) => handleEnddateChange(e, tournament._id)}
    />
  </div>

  <div>
    <label>Location:</label>
      <br />
    <input
      type="text"
      value={location[tournament._id] || tournament.location}
      onChange={(e) => handleLocationChange(e, tournament._id)}
    />
  </div>

  <div>
    <label>Organization:</label>
      <br />
    <input
      type="text"
      value={organization[tournament._id] || tournament.organization}
      onChange={(e) => handleOrganizationChange(e, tournament._id)}
    />
  </div>

  <div>
    <label>Winner: </label> <br /> <small>Note: You need to add teams first to be able to pick winner here.</small>
      <br />
    <select
      value={winner[tournament._id] || tournament.winner}
      onChange={(e) => handleWinnerChange(e, tournament._id)}
    >
      <option value="">Select Team</option>
      {teams.map((team) => (
        <option key={team._id} value={team._id}>
          {team.name}
        </option>
      ))}
    </select>
  </div>

  <div>
    <label>
     <input
          type="checkbox"
          checked={!!isPublished[tournament._id]} // safely handle undefined
          onChange={(e) => handleIsPublishedChange(e, tournament._id)}
        />
              &nbsp;Is Published
    </label>
  </div>

  {/* <div>
    <label>
     <input
          type="checkbox"
          checked={!!isCustomStanding[tournament._id]}
          onChange={(e) => handleIsCustomStandingChange(e, tournament._id)}
        />
              &nbsp;Custom Standing
    </label>
  </div> */}

 
</div>
<br />
<br />
      <button onClick={handleUpdateTournament}>Update</button>

    </div>
  );
};

export default UpdateTournament;
